import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./css/reset.css";
import "./css/App.css";
import NewNavbar from "./components/NewNavbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Resume from "./components/Resume";
import Project from "./components/Project";
import profilePic from "./images/profilePic-pink-gradient.jpg";
import nsccLogo from "./images/nscc-logo-small.png";
import smuLogo from "./images/smu-logo.png";
import techIcons from "./images/tech_icons/super-canvas1.png";
import techIconsWide from "./images/tech_icons/super-canvas2.png";
import resumePreview from "./images/resume-preview1.png";
import dota2Preview from "./images/project_images/dota2Preview.png";
import hairbyholtPreview from "./images/project_images/hairbyholtPreview.png";
import projectsPreview from "./images/projects-preview.png";
import mealdbPreview from "./images/project_images/mealdbPreview.png";
import foodDatabasePreview from "./images/project_images/foodDatabasePreview.png";
import wordpressThemePreview from "./images/project_images/wordpressThemePreview.png";

export default class App extends React.Component {
   constructor(props) {
      super(props);
      this.state = 
      {
         projects: 
         [
            {
               name: "hairbyholt",
               title: "Studio Métamorphose",
               description: `A business card website made for a hair stylist 
                  client based in Montreal. Built as a final group project before 
                  graduating from NSCC. `,
               image: hairbyholtPreview,
               siteLink: "https://studiometamorphose.netlify.app/",
               tags: ["React", "Bootstrap", "AWS"],
               summary: `I worked in a team of 4 to create a new website for a 
                  hair stylist as a final project at NSCC. Our client was thrilled 
                  about the new site, as it reflected their brand image very well.`,
               reflection: `This project taught me how important good 
                  communication and coordination is for a project's progress and 
                  success. At first, we struggled with keeping tabs on who was 
                  working on what, and when it would be done. We decided to start 
                  having bi-weekly, sometimes weekly meetings and group work 
                  sessions to make sure we were all on track and goals were clear. 
                  We made progress very quickly after these changes, and our site 
                  turned out great.`
            },
            {
               name: "dota2",
               title: "Dota 2 Heroes",
               description: `A data driven front-end for displaying hero 
                  information from the popular game Dota 2.`,
               image: dota2Preview,
               siteLink: "https://w0304379-fullstackapp.herokuapp.com/",
               tags: ["React", "Bootstrap", "MongoDB", "ExpressJS", "Heroku"],
               summary: `An assignment I did in the Full stack programming 
                  course at NSCC. It's a React front-end that fetches hero data 
                  from an Express API that we also built in the class. You can 
                  register or sign in with an account stored on the cloud 
                  database, and add, edit, and delete heroes.`
            },
            {
               name: "wordpressThemePreview",
               title: "WordPress Theme",
               description: `A WordPress theme for a news site.`,
               image: wordpressThemePreview,
               tags: ["WordPress", "PHP", "Bootstrap", "HTML"],
               summary: `A project I worked on in the Developing for Content 
                  Management Systems course at NSCC. It's a theme for a (fake) 
                  WordPress news site. The theme produces the layout, styling, 
                  and functionality of the site, with a color scheme option to 
                  switch between blue, red, and black site accent colors.`
            },
            {
               name: "mealdb",
               title: "MealDB Client",
               description: `A web client for fetching data from a food and 
                  recipe database "The MealDB" and displaying the results on 
                  the page.`,
               image: mealdbPreview,
               tags: ["JavaScript", "Bootstrap", "SCSS", "HTML"],
               summary: `An assignment I did in the Client Side programming 
                  course at NSCC. It's a simple web page with a script that 
                  connects to The MealDB's API and displays the response object. 
                  You can search for a recipe or request a random one.`
            },
            {
               name: "fooddatabase",
               title: "Food Database",
               description: `A desktop app for storing and viewing foods.`,
               image: foodDatabasePreview,
               tags: ["JavaScript", "Electron", "SQLite", "CSS", "HTML"],
               summary: `An assignment I did in the Electron course at NSCC. 
                  It's an Electron app with multiple windows (not shown in 
                  picture) that lets you add, edit, or delete food items. You 
                  can also search for a food by its name. The app also features 
                  a dark and light theme.`
            },
         ]
      }
   }

   render() {
      return (
         <React.Fragment>
            <NewNavbar/>
            <Routes>
               <Route path="/" element={<Home profilePic={profilePic} nsccLogo={nsccLogo} smuLogo={smuLogo} techIcons={techIcons} techIconsWide={techIconsWide} projectsPreview={projectsPreview} />} />
               <Route path="/projects" element={<Projects projects={this.state.projects} />} />
               <Route path="/resume" element={<Resume resumePreview={resumePreview} />} />
               <Route path="/projects/:name" element={<Project/>} />
            </Routes>
            <Footer/>
         </React.Fragment>
      );
   }
}
